import React from 'react';

import { ErrorMessage } from '../common';
import { ErrorMessageProps } from '../ErrorMessage';

export const exchangeErrorMessage = (title: string, paragraph: string, onFinish: () => void): ErrorMessageProps => ({
    heading: title,
    body: <ErrorMessage message={paragraph} onFinish={onFinish} withTitle={false} />,
});
